import { render, staticRenderFns } from "./SingleChoiceQuestions.vue?vue&type=template&id=60727904&scoped=true"
import script from "./SingleChoiceQuestions.vue?vue&type=script&lang=js"
export * from "./SingleChoiceQuestions.vue?vue&type=script&lang=js"
import style0 from "./SingleChoiceQuestions.vue?vue&type=style&index=0&id=60727904&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60727904",
  null
  
)

export default component.exports